<template>
  <RouterView />
</template>

<script>
import { READ, CREATE } from '@/plugins/user'
export default {
  data () {
    return {
      title: 'Customer Service',
      breadcrumb: {
        name: 'Customer Service',
        route: { name: 'customerservice' }
      },
      sidebar: [
        {
          icon: ['fal', 'chart-line'],
          route: { name: 'customerservice-dashboard' },
          name: 'Dashboard'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.account),
          icon: ['fal', 'briefcase'],
          route: { name: 'customerservice-accounts' },
          name: 'Accounts'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.pickup),
          icon: ['fal', 'person-dolly'],
          route: { name: 'customerservice-pickups' },
          name: 'Pickups'
        },
        {
          hidden: this.$user.cannot([READ, CREATE], 'notification_template'),
          icon: ['fal', 'envelope-open-text'],
          route: { name: 'customerservice-campaigns' },
          name: 'Campaigns'
        },
        {
          hidden: this.$user.cannot(READ, 'enquiry_enquirymain'),
          icon: ['fal', 'exchange'],
          route: { name: 'customerservice-enquiries' },
          name: 'Enquiries'
        }
      ]
    }
  }
}
</script>
